import { View, type ViewProps } from 'react-native'
import { AppView } from '~/components/layout/AppView'
import { ScrollContextProvider } from '~/components/layout/ScrollContext'
import { cn } from '~/lib/utils'
import { ErrorBoundary } from '../ErrorBoundary'

export default function ScreenView({
  className,
  children,
  innerClassName,
  ...props
}: ViewProps & {
  innerClassName?: string
}) {
  return (
    <ErrorBoundary>
      <AppView className={cn('mx-2 w-[calc(100%-1rem)]', className)} {...props}>
        <View className={cn('relative mx-auto w-full max-w-xl flex-initial', innerClassName)}>
          <ScrollContextProvider>{children}</ScrollContextProvider>
        </View>
      </AppView>
    </ErrorBoundary>
  )
}
